// Email password regex that validates:
// - (?=.*[A-Z]) - At least one uppercase letter
// - (?=.*[a-z]) - At least one lowercase letter
// - (?=.*[0-9]) - At least one digit
// - (?=.*[#?!@$%^&*-]) - At least one special character from the allowed set
// - [\x20-\x7E]{12,} - Only ASCII characters (32-126) and minimum 12 characters
import {
  checkAdjacentKeyboardKeys,
  checkConsecutiveCharacters,
  checkIdenticalCharacters,
  checkLength,
  checkLowerCaseChar,
  checkNumber,
  checkSpecialChar,
  checkUpperCaseChar,
} from '../common/validations';
import {
  CPANEL_EMAIL_PASSWORD_REGEX,
  PASSWORD_REGEX_8,
  PASSWORD_REGEX_12,
} from '../regex/constants';

export const isValidCPanelEmailPassword = (value: string) => {
  return CPANEL_EMAIL_PASSWORD_REGEX.test(value);
};

export const validatePassword12Chars = (value: string) => {
  return PASSWORD_REGEX_12.test(value);
};

export const isValidPassword8Chars = (value: string) => {
  return PASSWORD_REGEX_8.test(value);
};

export const validation = (password: string) => {
  const passwordRules = {
    // 1. Password must be at least 8 characters long
    length: checkLength(password),

    // 2. Password must include at least one lowercase letter
    lowerCase: checkLowerCaseChar(password),

    // 3. Password must include at least one uppercase letter
    upperCase: checkUpperCaseChar(password),

    // 4. Password must include at least one digit
    digit: checkNumber(password),

    // 5. Password must include at least one special character
    specialChar: checkSpecialChar(password),

    // 6. Password should not contain consecutive numbers (e.g.123, abc)
    noConsecutiveDigits: checkConsecutiveCharacters(password),

    // 7. Password should not contain Identical chars '11', '22'  ,'aa', 'bb'
    noIdenticalChars: checkIdenticalCharacters(password),

    // 8. Password should not contain three adjacent keys from the keyboard (e.g., qwerty, asdf, zxcvbn)
    noAdjacentKeyboardKeys: checkAdjacentKeyboardKeys(password),
  };

  const isPasswordValid = Object.values(passwordRules).every(Boolean);
  return isPasswordValid;
};
